import { render, staticRenderFns } from "./color-simple.vue?vue&type=template&id=9859ad28&scoped=true"
import script from "./color-simple.vue?vue&type=script&lang=js"
export * from "./color-simple.vue?vue&type=script&lang=js"
import style0 from "./color-simple.vue?vue&type=style&index=0&id=9859ad28&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9859ad28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/apps/wpms/web/wind-plannerDev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9859ad28')) {
      api.createRecord('9859ad28', component.options)
    } else {
      api.reload('9859ad28', component.options)
    }
    module.hot.accept("./color-simple.vue?vue&type=template&id=9859ad28&scoped=true", function () {
      api.rerender('9859ad28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/color-simple.vue"
export default component.exports